import Heading, { type HeadingProps } from "@client/controls/HTML/Heading/component";
import Icon from "@client/controls/Icon/component";
import { IconType } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import { i18nFormatN } from "@common/lib/i18n";
import moment from "moment";
import React from "react";
import { type BlogDetailHeader } from "../../types";

export interface BlogDetailPostTitleProps {
  post: BlogDetailHeader.Post;
  headingProps: HeadingProps;
  postInfoStyle: React.CSSProperties | undefined;
}

export default ({ headingProps, post, postInfoStyle }: BlogDetailPostTitleProps) => {
  const i18n = useI18n();

  return (
    <div className="post-title-container">
      <Heading className="post-title" {...headingProps} content={post.title} />
      <div className="post-info" style={postInfoStyle}>
        <span className="post-info-user">
          <Icon iconClassName={IconType.User} />
          {post.authorName}
        </span>
        <span className="post-info-date">
          <Icon iconClassName={IconType.Calendar} />
          {moment(post.publishedOnDate).format("L")}
        </span>
        {post.allowComments && (
          <span className="post-info-comments">
            <Icon iconClassName={IconType.Comments} />
            {i18nFormatN(post.commentCount, i18n.oneComment, i18n.nComments)}
          </span>
        )}
      </div>
    </div>
  );
};
